import Accordion from '@bit/pitcher.components.accordion';

window.addEventListener('load', () => {
	const accordions = document.querySelectorAll('[data-accordion]');
	for (let i = 0; i < accordions.length; i++) {
		const accordion = accordions[i];
		new Accordion(accordion, {
			classNames: {
				accordionItem: '.o-accordion__item',
				accordionHeader: '.o-accordion__header',
				accordionContent: '.o-accordion__content'
			},
			multiSelectable: false,
			initialOpen: 'first'
		});
	}
})



// WEBPACK FOOTER //
// ./js/modules/accordion.js